"use client";

import { useRef } from "react";
import gsap from "gsap";
import { useGSAP } from "@gsap/react";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ArrowRight, Sparkles } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
gsap.registerPlugin(useGSAP, ScrollTrigger);
const solutions = [{
  id: "1",
  numberLabel: "01 — EXCELÊNCIA",
  title: "Limpeza de Tanques e Recipientes de Vinho",
  description: "Os tanques de fermentação, tanques de loteamento, tanques de armazenamento, barris e recipientes de pequenas dimensões requerem uma limpeza eficaz para ajudar a manter a qualidade do vinho e prevenir a contaminação. O equipamento adequado de limpeza de tanques pode reduzir o tempo de limpeza, melhorar a cobertura e proporcionar o impacto necessário para remover resíduos das superfícies interiores. A Spraying Systems Co. oferece soluções de limpeza de tanques para uma vasta gama de recipientes de adega, desde barris e contentores pequenos até grandes tanques em aço inoxidável. As opções incluem esferas de pulverização estáticas, limpa-tanques rotativos e máquinas de limpeza de tanques de elevado impacto para exigências de limpeza mais difíceis.",
  imageSrc: "https://simple-elk.10web.cloud/wp-content/uploads/2026/08/Captura-de-ecra-2026-08-06-as-16.37.27.png?v=iy4rqd29e7o",
  imageAlt: "Bico de lavagem de tanques TankJet em funcionamento",
  imageSrcset: "https://simple-elk.10web.cloud/wp-content/uploads/2026/08/Captura-de-ecra-2026-08-06-as-16.37.27.png?v=wqia8dzih4j-wvc-srcset",
  imageSizes: "https://simple-elk.10web.cloud/wp-content/uploads/2026/08/Captura-de-ecra-2026-08-06-as-16.37.27.png?v=kwzl9zcz03c-wvc-sizes",
  linkPath: "/TankCleaningPage"
}, {
  id: "2",
  numberLabel: "02 — PARCERIA",
  title: "Lavagem de Adega, Zona de Esmagamento e Equipamentos",
  description: "As adegas dependem de uma limpeza e lavagem eficazes em toda a área de produção, zona de esmagamento, adega, sala de barris e linha de engarrafamento. Pistolas de pulverização, bicos de lavagem, enroladores de mangueira e sistemas de lavagem aquecidos a vapor ajudam os operadores a limpar de forma eficiente pavimentos, equipamentos, prensas, transportadores, enchedoras, contentores e áreas de trabalho.\nO equipamento de pulverização adequado pode melhorar o impacto de limpeza, ajudando a reduzir o desperdício de água, a sobrespray e a fadiga do operador. Estão disponíveis produtos de lavagem duráveis para água quente, limpeza com produtos químicos e utilização quotidiana na adega.",
  imageSrc: "https://simple-elk.10web.cloud/wp-content/uploads/2026/08/Captura-de-ecra-2026-08-06-as-16.40.31.png?v=23xudp26vcm",
  imageAlt: "Sistema de secagem com facas de ar WindJet",
  imageSrcset: "https://simple-elk.10web.cloud/wp-content/uploads/2026/08/Captura-de-ecra-2026-08-06-as-16.40.31.png?v=1ezzw2e9zln-wvc-srcset",
  imageSizes: "https://simple-elk.10web.cloud/wp-content/uploads/2026/08/Captura-de-ecra-2026-08-06-as-16.40.31.png?v=znvptospzkm-wvc-sizes",
  linkPath: "/AirNozzlesAndBlowingProductsPage"
}, {
  id: "3",
  numberLabel: "03 — INOVAÇÃO",
  title: "Secagem de Garrafas e Sopro em Linhas de Embalagem",
  description: "A humidade em garrafas, latas, cartões ou embalagens pode abrandar a produção e causar problemas de rotulagem, codificação a jato de tinta, inspeção e embalagem em caixas. Os bicos de ar WindJet®, as facas de ar e os sistemas acionados por soprador proporcionam secagem e sopro uniformes para linhas de engarrafamento e embalagem de adegas.\nEstes sistemas ajudam a remover a água de enxaguamento e a condensação das garrafas antes da rotulagem ou codificação, apoiando também o sopro de cápsulas, fechos, transportadores e embalagens. As opções acionadas por soprador podem reduzir o consumo de ar comprimido e diminuir os custos operacionais.",
  imageSrc: "https://simple-elk.10web.cloud/wp-content/uploads/2026/08/Captura-de-ecra-2026-08-06-as-16.40.18.png?v=uu7evsned3i",
  imageAlt: "Linha de engarrafamento com lubrificação de correntes",
  imageSrcset: "https://simple-elk.10web.cloud/wp-content/uploads/2026/08/Captura-de-ecra-2026-08-06-as-16.40.18.png?v=y8qewf1saw9-wvc-srcset",
  imageSizes: "https://simple-elk.10web.cloud/wp-content/uploads/2026/08/Captura-de-ecra-2026-08-06-as-16.40.18.png?v=13dz81f067n-wvc-sizes",
  linkPath: "/AutomatedSprayingSystemsPage"
}];
export default function Solutions() {
  const containerRef = useRef<HTMLDivElement>(null);
  useGSAP(() => {
    gsap.from(".intro-animate", {
      opacity: 0,
      y: 28,
      duration: 0.7,
      stagger: 0.12,
      ease: "power3.out",
      scrollTrigger: {
        trigger: containerRef.current,
        start: "top 80%"
      }
    });
    gsap.from(".solution-card", {
      opacity: 0,
      y: 36,
      duration: 0.8,
      stagger: 0.15,
      ease: "power3.out",
      scrollTrigger: {
        trigger: ".solutions-grid",
        start: "top 80%"
      }
    });
  }, {
    scope: containerRef
  });
  return <section id="winesolutionsgrid" ref={containerRef} className="relative bg-background py-20 lg:py-28 overflow-hidden">
      {}
      <div className="absolute top-1/4 left-1/2 -translate-x-1/2 -translate-y-1/2 w-96 h-96 bg-primary/5 rounded-3xl blur-3xl pointer-events-none" />

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        {}
        <div className="max-w-3xl mx-auto text-center mb-16 lg:mb-20 space-y-4">
          <div className="intro-animate inline-block">
            <Badge variant="outline" className="px-3.5 py-1 text-xs font-medium tracking-wider uppercase border-border/80 bg-muted/50 text-foreground rounded-md gap-1.5">
              <Sparkles className="size-3.5 text-secondary" />
              Sistemas Especiais de Pulverização
            </Badge>
          </div>

          <h2 className="intro-animate font-default text-3xl sm:text-4xl md:text-5xl font-bold tracking-tight text-foreground leading-tight">Aplicações de Pulverização para a Indústria do Vinho</h2>

          <p className="intro-animate text-muted-foreground text-base sm:text-lg font-default leading-relaxed max-w-2xl mx-auto">A Spraying Systems Co. oferece uma gama completa de produtos de pulverização e soluções de engenharia para ambientes de produção de vinho. Os nossos produtos são concebidos para ajudar as adegas a limpar de forma mais eficaz, melhorar a secagem de garrafas, reduzir o consumo de recursos e apoiar práticas de sanitização consistentes.</p>
        </div>

        {}
        <div className="solutions-grid grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {solutions.map((item, i) => <div key={item.id} data-index={i} className="solution-card flex">
              <Card className="border border-border/80 bg-card hover:border-primary/30 shadow-md hover:shadow-lg transition-all duration-300 flex flex-col justify-between overflow-hidden rounded-xl w-full">
                <div>
                  {}
                  <div className="p-4 sm:p-5">
                    <div className="relative aspect-4/3 w-full overflow-hidden rounded-lg bg-muted">
                      <img src={item.imageSrc} data-wvc-srcset={item.imageSrcset} data-wvc-sizes={item.imageSizes} alt={item.imageAlt} loading="lazy" className="h-full w-full object-cover transition-transform duration-500 hover:scale-105" />
                    </div>
                  </div>

                  <CardHeader className="pt-2 pb-3 px-6">
                    <span className="text-xs font-mono font-medium tracking-widest text-muted-foreground uppercase">
                      {item.numberLabel}
                    </span>
                    <CardTitle className="font-default text-xl sm:text-2xl font-bold text-foreground mt-1">
                      {item.title}
                    </CardTitle>
                  </CardHeader>

                  <CardContent className="px-6 pb-6">
                    <p className="font-default text-sm sm:text-base text-muted-foreground leading-relaxed">
                      {item.description}
                    </p>
                  </CardContent>
                </div>

                <div className="px-6 pb-6 pt-2">
                  <Button asChild variant="outline" className="w-full justify-between group hover:bg-primary hover:text-primary-foreground border-border transition-all duration-300 rounded-md">
                    <Link to={item.linkPath}>
                      <span>Saber Mais</span>
                      <ArrowRight className="size-4 transition-transform duration-300 group-hover:translate-x-1" />
                    </Link>
                  </Button>
                </div>
              </Card>
            </div>)}
        </div>

        {}
        <div className="mt-16 text-center">
          <Button asChild size="lg" className="rounded-md font-medium px-8 shadow-md">
            <Link to="/ContactsPage">
              Consulte-nos para Soluções À Medida
              <ArrowRight className="size-4 ml-1" />
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}